import { Observable } from 'rxjs';

/**
 * Returns the global window object
 * @returns The window object
 */
export const getWindow = (): Window => window;

/**
 * Returns the window location object
 * @returns The location object
 */
export const getLocation = (): Location => window.location;

/**
 * Opens a URL in a new browser tab
 * @param url - The URL to open
 * @returns The opened window object
 */
export const openUrlInNewTab = (url: string): Window => window.open(url, '_blank');

/**
 * Opens a URL in the current browser tab
 * @param url - The URL to open
 * @returns The opened window object
 */
export const openUrl = (url: string): Window => window.open(url, '_self');

/**
 * Redirects to the origin with an optional path
 * @param path - Optional path to append to the origin
 */
export const redirectToOrigin = (path?: string): void => {
  let resultUrl = window.location.origin;

  if (path) {
    resultUrl += '/' + path.replace(/^\/+/, '');
  }

  openUrl(resultUrl);
};

/**
 * Creates an Observable that emits when the specified element is resized
 * @param element - The HTML element to observe for resize events
 * @returns An Observable that emits ResizeObserverEntry arrays
 */
export const observeResize = (element: HTMLElement): Observable<ResizeObserverEntry[]> => {
  return new Observable((observer) => {
    const resizeObserver = new ResizeObserver((resizeObserverEntries: ResizeObserverEntry[]) => {
      observer.next(resizeObserverEntries);
    });
    resizeObserver.observe(element);
    return () => resizeObserver.disconnect();
  });
};

/**
 * Returns the current URL path and search parameters
 * @returns The current pathname and search string
 */
export const getCurrentUrl = (): string => location.pathname + location.search;
